export default "__VITE_ASSET__TE0Yaxbk__"